module.exports = __webpack_public_path__ + "static/media/Portrait-10223.e2a690fa.jpg";